/**
 * Layout Architecture - Public API
 *
 * Export all types, constants, and utilities for the new layout system.
 */

// Core Strategy Interface
export type {LayoutStrategy} from './LayoutStrategy';

// Types
export type {
  AxisType,
  ControlDefinition,
  GridCell,
  GridData,
  GridMetadata,
  GridRow,
  LayoutMode,
  SlotRegistry,
  TransformFunction,
  TransformInput,
} from './types';

// Constants
export {
  CONTROL_PLACEMENT,
  LAYOUT_CONSTANTS,
  MEDIA_DIMENSIONS,
  PERFORMANCE_THRESHOLDS,
} from './constants';

// Slot Helpers
export {DEFAULT_SLOTS} from './utils/slots';

// Layout Registry
export {
  getLayoutStrategy,
  getRegisteredLayoutIds,
  registerLayoutStrategy,
} from './Layouts';

// Built-in Layout Strategies
export {GalleryLayout} from './GalleryLayout';
export {GridLayout} from './GridLayout';

// Adapter (for gradual migration)
export {
  adaptGridDataToLayout,
  createEmptyLayout,
} from './utils/gridDataAdapter';

// Comparison utilities (for validation during migration)
export {
  assertArchitecturesMatch,
  compareArchitectures,
  logComparisonResult,
} from './utils/compareArchitectures';

// Transform Functions
export {
  buildSlotRegistry,
  dispatchTransform,
  isValidTransformInput,
  safeDispatchTransform,
} from './utils/transformDispatcher';

// Renderers
export type {
  GalleryRendererProps,
  GridRendererProps,
  TileRendererProps,
} from './renderers';
export {
  GalleryRenderer,
  GridRenderer,
  TileRenderer,
} from './renderers';
